"use client";
import { useEffect } from "react";
import { inNativeShell, openInSystemBrowser } from "./capacitor";

/**
 * PDFs, inside the app. An Android WebView cannot render application/pdf and has
 * no download handler, so an invoice or credit-note link simply did nothing when
 * tapped — no error, no file (found on a real phone with Serviceitz, 18 Sep 2026).
 * One capture-phase listener instead of editing every link: anything that is a
 * PDF — a signed storage URL ending .pdf, or any /pdf route — is handed to the
 * system browser, which can display and save it. Covers links added later too.
 */
export function PdfOpener() {
  useEffect(() => {
    if (!inNativeShell()) return;
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0) return;
      const a = (e.target as Element | null)?.closest?.("a[href]") as HTMLAnchorElement | null;
      if (!a) return;
      const url = new URL(a.href, location.href);
      const isPdf = /\.pdf$/i.test(url.pathname) || url.pathname.endsWith("/pdf") || url.pathname.includes("/storage/v1/object/");
      if (!isPdf) return;
      e.preventDefault();
      e.stopPropagation();
      openInSystemBrowser(url.href);
    };
    document.addEventListener("click", onClick, true);
    return () => document.removeEventListener("click", onClick, true);
  }, []);
  return null;
}
